import request from '@/utils/request'

// 查询行业列表
export function listIndustry(data) {
  return request({
    url: '/merchant/industry/list',
    method: 'post',
    data: data
  })
}
